// src/ThemeContext.js
import React, { createContext, useState, useMemo, useContext } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';

export const ThemeModeContext = createContext({
  toggleThemeMode: () => {},
  mode: 'dark',
});

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
          primary: { main: '#1976d2' },
          secondary: { main: '#dc004e' },
          background: { default: '#f4f6f8', paper: '#ffffff' },
          text: { primary: '#212B36', secondary: '#637381' },
        }
      : {
          primary: { main: '#63b3ff' },
          secondary: { main: '#f77e9a' },
          background: { default: '#161c24', paper: '#212b36' },
          text: { primary: '#ffffff', secondary: '#919eab' },
          divider: 'rgba(145, 158, 171, 0.24)',
        }),
  },
  typography: { fontFamily: 'Inter, sans-serif' },
  components: { MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } } },
});

export const CustomThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('dark');
  const themeMode = useMemo(() => ({
    toggleThemeMode: () => {
      setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    },
    mode,
  }), [mode]);

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <ThemeModeContext.Provider value={themeMode}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </ThemeModeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ThemeModeContext);